module.exports = __webpack_public_path__ + "img/folder.0d100340.svg";